module.exports = __webpack_public_path__ + "assets/images/project/map-logo-svg/desktop.svg?v=0821fca1";